import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { useSetAtom } from 'jotai';

import { makeStyles } from '@material-ui/styles';
import { useCurrentUser } from '@bizzabo/entities';

import WelcomeCard from '../WelcomeCard';
import ContactListWrapper from '../../../../components/ContactListWrapper';
import useTypeTracking from '../../../../../analytics';
import { useMessages } from '../../../contexts/MessagesContext';
import { createChannelAtom } from '../../..';

const ZeroView: React.FC = () => {
    const classes = useStyles();
    const [isFirstTime, setIsFirstTime] = useLocalStorage('Meetings.zeroFirstTime', true);
    const { trackClickEvent } = useTypeTracking();
    const { eventId, setIsEmptyState, searchText } = useMessages();
    const { data: user } = useCurrentUser(eventId);
    const createChannelWith = useSetAtom(createChannelAtom);

    useEffect(() => {
        setIsEmptyState(true);

        return () => {
            setIsEmptyState(false);
        };
    }, []);

    const removeCard = () => {
        setIsFirstTime(false);
        trackClickEvent({
            subCategory: 'EMPTY_STATE_CLEARED',
        });
    };

    const handleContactItemClick = (attendeeId: number) => {
        if (attendeeId) {
            createChannelWith({ members: [attendeeId], eventId });
        }
    };

    return (
        <div className={classes.wrapper}>
            <WelcomeCard isFirstTime={isFirstTime} user={user} removeCard={removeCard} />
            <ContactListWrapper
                eventId={eventId}
                searchTerm={searchText}
                onContactItemClick={handleContactItemClick}
            />
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        wrapper: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
    }),
    { classNamePrefix: ZeroView.name }
);

export default ZeroView;
